module.exports = __webpack_public_path__ + "img/hexin5.f622a90b.png";